<div>
  <div class="modal-header">
    <h3>Select One</h3>
  </div>
  <div class="modal-body">
    <div class="row" *ngIf="application_type !== 'renewal'" style="display: flex; justify-content: space-around">
      <div class="col-xs-12 col-sm-3 col-sm-offset-3 text-center" style="padding-bottom: 10px;">
        <button class="btn btn-default" (click)="close({type: 'new'})">New Site</button>
      </div>
      <div class="col-xs-12 col-sm-3 text-center">
        <button class="btn btn-default" (click)="login('pesticides_noa')">Existing Site</button>
      </div>
    </div>
  </div>
  <div class="modal-footer">
  </div>
</div>
